// Key = Completed item
// Value = Component
export const COMPONENTS: { [key: string]: string } = {
  "Superior Cooldown": "Improved Cooldown",
  "Escalating Exposure": "Mystic Vulnerability",
  "Mystic Slow": "Suppressor",
  "Boundless Spirit": "Improved Spirit",
  "Titanic Magazine": "Basic Magazine",
  "Point Blank": "Close Quarters",
  Headhunter: "Headshot Booster",
  "Pristine Emblem": "High-Velocity Mag",
  Sharpshooter: "Long Range",
  Silencer: "Slowing Bullets",
  Fortitude: "Extra Health",
  "Superior Stamina": "Extra Stamina",
  Lifestrike: "Melee Lifesteal",
  "Enduring Speed": "Sprint Boots",
  "Improved Bullet Armor": "Bullet Armor",
  "Improved Spirit Armor": "Spirit Armor",
  "Debuff Remover": "Debuff Reducer",
  "Healing Nova": "Healing Rite",
  "Rapid Recharge": "Extra Charge",
  "Improved Spirit": "Extra Spirit",
  "Improved Burst": "Mystic Burst",
  "Improved Reach": "Mytic Reach",
  "Superior Duration": "Duration Extender",
  "Arcane Surge": "Kinetic Dash",
  "Spirit Snatch": "Spirit Strike",
  "Spellslinger Headshots": "Soul Shredder Bullets",
  Frenzy: "Berserker",
};
